import { Controller } from "@hotwired/stimulus"

// Click handlers for the markdown toolbar buttons. Each button declares the
// snippet it should insert via `data-snippet` and (optionally) a `data-wrap`
// flag — when wrap is true, the snippet wraps the current selection.
export default class extends Controller {
  static targets = ["textarea"]

  insert(event) {
    event.preventDefault()
    const btn = event.currentTarget
    const snippet = btn.dataset.snippet || ""
    const wrap = btn.dataset.wrap === "true"
    const placeholder = btn.dataset.placeholder || ""
    wrap ? this.wrapSelection(snippet, placeholder) : this.insertAtCursor(snippet)
  }

  wrapSelection(token, placeholder) {
    const ta = this.textareaTarget
    const start = ta.selectionStart
    const end = ta.selectionEnd
    const selected = ta.value.slice(start, end) || placeholder
    const before = ta.value.slice(0, start)
    const after = ta.value.slice(end)
    const next = `${before}${token}${selected}${token}${after}`
    ta.value = next
    const cursor = start + token.length + selected.length
    ta.selectionStart = ta.selectionEnd = cursor
    ta.focus()
    ta.dispatchEvent(new Event("input", { bubbles: true }))
  }

  insertAtCursor(text) {
    const ta = this.textareaTarget
    const start = ta.selectionStart
    const end = ta.selectionEnd
    const before = ta.value.slice(0, start)
    const after = ta.value.slice(end)
    ta.value = `${before}${text}${after}`
    ta.selectionStart = ta.selectionEnd = start + text.length
    ta.focus()
    ta.dispatchEvent(new Event("input", { bubbles: true }))
  }
}
